import React, { useContext, useState } from 'react'
import Drawer from '@mui/material/Drawer';

import { NavLink } from 'react-router-dom'
import { IoMenu, IoClose } from "react-icons/io5";

import { useScroll } from './../../hooks/useScroll'
import { TabContext } from '../../contexts/TabContext'

import './Navbar.css'

import meclogo from '../../assets/png/meclogo.png'

const navItems = [
  {
    route: '',
    name: 'Home',
  },
  {
    route: 'about',
    name: 'About',
  },
  {
    route: 'admission',
    name: 'Admission',
  },
  {
    route: 'academics',
    name: 'Academics',
    dropdown: [
      {
        tab: 1,
        name: 'POs',
      },
      {
        tab: 2,
        name: 'Programmes Offered',
      },
      {
        tab: 3,
        name: 'Syllabus',
      },
    ]
  },
  {
    route: 'people',
    name: 'People',
    dropdown: [
      {
        tab: 1,
        name: 'Head of Department',
      },
      {
        tab: 2,
        name: 'Faculty',
      },
      {
        tab: 3,
        name: 'Students',
      },
      {
        tab: 4,
        name: 'Alumni',
      },
    ]
  },
  {
    route: 'placements',
    name: 'Placements',
    dropdown: [
      {
        tab: 1,
        name: 'Why MEC?',
      },
      {
        tab: 2,
        name: 'Placement Statistics',
      },
      {
        tab: 3,
        name: 'Internship Statistics',
      }
    ]
  },
  {
    route: 'facilities',
    name: 'Facilities',
  },
  // {
  //   route: 'resources',
  //   name: 'Resources',
  // },
  {
    route: 'activities',
    name: 'Activities',
    dropdown: [
      {
        tab: 1,
        name: 'Achievements',
      },
      {
        tab: 2,
        name: 'Student Clubs',
      },
      {
        tab: 3,
        name: 'Projects',
      },
      {
        tab: 4,
        name: 'Events',
      }
    ]
  },
  {
    route: 'contact',
    name: 'Contact Us',
  },
]

function Navbar() {

  const { updateDropdownTab } = useContext(TabContext);
  const [drawer, setDrawer] = useState(false);

  const { scrollDirection } = useScroll();

  const styles = {
    active: {
      display: 'flex'
    },
    hidden: {
      display: 'none'
    }
  }


  const handleDrawerOpen = () => {
    setDrawer(true);
  };

  const handleDrawerClose = () => {
    setDrawer(false);
  };

  return (
    <div className='navbar'>
      <div className='navbar__header' >
        <div className='nav_hr' />
        <div className='navheader__component' style={scrollDirection === "up" ? styles.hidden : styles.active} >
          <h1>Computer <span className='secondary'>Engineering</span></h1>
          <div className='nav_logo'>
            <a href='http://www.mec.ac.in/' target='_blank' rel="noreferrer">
              <img src={meclogo} alt=" " className='navbar_img' />
            </a>
          </div>
          <div className='nav_hamburger' onClick={handleDrawerOpen}>
            <IoMenu className='nam_menu_icon' />
          </div>
        </div>
      </div>
      <div className='navbar_comp'>
        {navItems.map((nav, id) => (
          <NavLink
            key={id}
            to={`/${nav.route}`}
            className='nav__link'
            style={({ isActive }) => ({
              color: isActive ? '#AE9142' : 'rgba(12, 35, 64, 0.7)',
              fontWeight: isActive ? '800' : '600',
            })}
          >
            <span onClick={() => updateDropdownTab(1)}>{nav.name}</span>
            <div className='navDropdown'>
              {nav.dropdown && nav.dropdown.map((drop, idd) => (
                <span
                  key={idd}
                  to={`/${nav.route}`}
                  className='nav__dropdown_link'
                  onClick={() => updateDropdownTab(drop.tab)}
                >
                  {drop.name}
                </span>
              ))}
            </div>
          </NavLink>
        ))}
      </div>
      <Drawer
        disableScrollLock={true}
        anchor="top"
        open={drawer}
        onClose={handleDrawerClose}
        sx={{
          borderRadius: 20,
          width: '300px',
        }}
      >
        <div className='navbar__mob'>
          <div className='navbar__mob__container'>
            <div className='navbar__mob_header'>
              <div className='nav_hr' />
              <div className='nav_logo'>
                <img src={meclogo} alt=" " className='navbar_img' />
              </div>
              <div className='nav_hamburger' onClick={handleDrawerClose}>
                <IoClose className='nam_menu_icon' />
              </div>
            </div>
            <h1 className='nav_mob_header'>Computer <span className='secondary'>Engineering</span></h1>
            <div className='navbar_comp_mob'>
              {navItems.map((nav, id) => (
                <NavLink
                  key={id}
                  to={`/${nav.route}`}
                  className='nav__link_mob'
                  style={({ isActive }) => ({
                    color: isActive ? '#0C2340' : '#ffffff',
                    backgroundColor: isActive ? '#AE9142' : '#0C2340',
                  })}
                  onClick={handleDrawerClose}
                >
                  <span onClick={() => updateDropdownTab(1)}>{nav.name}</span>
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </Drawer>

    </div>
  )
}

export default Navbar